// menubar-keys: WAI-ARIA menubar/submenu 키보드 핸들러가 공유하는 utility.
// main-nav 와 mega-menu 양쪽에서 사용되므로 별도 모듈로 분리 (순환 import 방지).

export const MENUBAR_TRIGGER_ATTR = 'data-menubar-trigger';

// key 로 활성 trigger 의 anchor 를 찾아 focus 복귀.
export const focusTriggerByKey = (key: string | undefined) => {
  if (!key) return;
  document
    .querySelector<HTMLElement>(`[${MENUBAR_TRIGGER_ATTR}="${key}"]`)
    ?.focus();
};

// 배열 안에서 wrap-around 된 다음 index 를 계산. ArrowLeft/Right (menubar),
// ArrowUp/Down (submenu) 가 공통으로 사용.
export const wrapIndex = (current: number, offset: number, length: number) =>
  ((current + offset) % length + length) % length;
